import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMicrophoneAudio = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.25 6.75C7.25 4.12665 9.37665 2 12 2C14.6234 2 16.75 4.12665 16.75 6.75V11.75C16.75 14.3734 14.6234 16.5 12 16.5C9.37665 16.5 7.25 14.3734 7.25 11.75V6.75ZM12 3.5C10.2051 3.5 8.75 4.95507 8.75 6.75V11.75C8.75 13.5449 10.2051 15 12 15C13.7949 15 15.25 13.5449 15.25 11.75V11.5H13C12.5858 11.5 12.25 11.1642 12.25 10.75C12.25 10.3358 12.5858 10 13 10H15.25V8.5H14C13.5858 8.5 13.25 8.16421 13.25 7.75C13.25 7.33579 13.5858 7 14 7H15.25V6.75C15.25 4.95507 13.7949 3.5 12 3.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 11C5.41421 11 5.75 11.3358 5.75 11.75C5.75 15.2018 8.54822 18 12 18C15.4518 18 18.25 15.2018 18.25 11.75C18.25 11.3358 18.5858 11 19 11C19.4142 11 19.75 11.3358 19.75 11.75C19.75 15.7772 16.6783 19.087 12.75 19.4642V22.25C12.75 22.6642 12.4142 23 12 23C11.5858 23 11.25 22.6642 11.25 22.25V19.4642C7.3217 19.087 4.25 15.7772 4.25 11.75C4.25 11.3358 4.58579 11 5 11Z",
		fill: "currentColor"
	})]
});
export { SvgIconMicrophoneAudio as ReactComponent };
